/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function SkuList(state = {}, action) {
    switch (action.type) {
    case getConstants.ADD_SKU_CATEGORY:
        return {
            type: 'SKU LIST',
            SkuList: action.user,
        };
    case getConstants.REMOVE_PAGINATION:
        return {
            type: 'REMOVE_PAGINATION',
            message: action.user,
        };
    default:
        return state;
    }
}
